import type { SVGProps } from 'react'

const SvgStepOver = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 -960 960 960' {...props}>
    <path d='M395-235q-35-35-35-85t35-85q35-35 85-35t85 35q35 35 35 85t-35 85q-35 35-85 35t-85-35m293-325q-32-54-86.5-87T480-680q-77 0-138 44t-87 113q-6 17-18.5 30T207-480q-18 0-29-14.5t-6-31.5q28-102 112.5-168T479-760q73 0 135 29.5T720-650v-70q0-17 11.5-28.5T760-760q17 0 28.5 11.5T800-720v200q0 17-11.5 28.5T760-480H560q-17 0-28.5-11.5T520-520q0-17 11.5-28.5T560-560z' />
  </svg>
)

export default SvgStepOver
